import React, { useState, useRef } from "react";
import { Button, Dialog, DialogContent, DialogActions, DialogTitle, DialogContentText } from '@mui/material';
import TextField from '@mui/material/TextField';
import Modal from 'react-bootstrap/Modal';
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Input, MenuItem, Select, InputLabel } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

const BankAccountModal = (props) => {

  const { bankaccounts: listBankAccounts } = useSelector((state) => state.bankaccounts);
  const [active, setActive] = useState(true);
  const [name, setName] = useState("");
  const [iban, setIban] = useState("");
  const [bic, setBic] = useState("");
  const [address, setAddress] = useState("");
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (props.show && props.selectedBankAccount != null && !loaded) {

      const filtered = listBankAccounts.filter((bankaccount) => { return bankaccount.id === props.selectedBankAccount.id; });
      filtered.map(
        (bankaccount) => (
          setActive(bankaccount.active),
          setName(bankaccount.name),
          setIban(bankaccount.iban),
          setBic(bankaccount.bic),
          setAddress(bankaccount.address),
          setLoaded(true)
        )
      );
    }
    if (!props.show) {
      clearUI();
    }
  });

  const clearUI = () => {
    setLoaded(false);
    setName("");
    setIban("");
    setBic("");
    setAddress("");
    setActive(true);
    props.setSelectedBankAccount(null);
  }

  const handleSubmit = () => {
    let bankaccount_tmp = props.selectedBankAccount;
    bankaccount_tmp.name = name;
    bankaccount_tmp.active = active;
    bankaccount_tmp.iban = iban;
    bankaccount_tmp.bic = bic;
    bankaccount_tmp.address = address;
    props.setSelectedBankAccount(bankaccount_tmp);
    props.handleSubmit();
    clearUI();
  }

  return (
    <Modal {...props} size="s" centered>

      <Modal.Body>
        <Grid container spacing={1}>
          <Grid item xs={9}>
            <label htmlFor="name">Bank account</label>
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Switch onChange={(e) => setActive(e.target.checked)} checked={active} />} label="Active" />
          </Grid>
        </Grid>

        <InputLabel>Name</InputLabel>
        <Input
          type="text"
          className="form-control"
          name="locality"
          size="small"
          value={name}
          onChange={(e) => setName(e.target.value)}>
        </Input>

        <InputLabel>IBAN</InputLabel>
        <Input
          type="text"
          className="form-control"
          name="locality"
          size="small"
          value={iban}
          onChange={(e) => setIban(e.target.value)}>
        </Input>

        <InputLabel>BIC</InputLabel>
        <Input
          type="text"
          className="form-control"
          name="locality"
          size="small"
          value={bic}
          onChange={(e) => setBic(e.target.value)}>
        </Input>

        <InputLabel>Address</InputLabel>
        <Input
          type="text"
          className="form-control"
          name="locality"
          size="small"
          value={address}
          onChange={(e) => setAddress(e.target.value)}>
        </Input>

      </Modal.Body>

      <Modal.Footer>
        <Button variant="contained" onClick={handleSubmit} fullWidth>
          Submit
        </Button>
      </Modal.Footer>

    </Modal>
  );
};

export default BankAccountModal;